import React, { useMemo } from 'react'
import { Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
} from '@fortawesome/free-solid-svg-icons'
import { capitalize } from 'lodash'
import { useStyles as commonStyles } from '../../FlyOutStorefront.styles'
import { TemplateInCreation } from '../../../../modules/storefront/templateCreation/reducer'
import { useStyles } from './TemplateCardProperties.styles'
import { cardOrientations } from '../../../../utils/templateCreationConstants'
import {
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
} from '@labrav/react-components'
import { ListingCardInCreation } from '../../../../modules/storefront/listingCardCreation/reducer'

export const TemplateCardProperties: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()
  const { values, setFieldValue } = useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values

  const alignments = [
    { id: 'left', icon: faAlignLeft },
    { id: 'center', icon: faAlignCenter },
    { id: 'right', icon: faAlignRight },
  ]

  const handleAlignmentChange = (value: string, type: string) => () => {
    if (type === 'orientation') {
      setFieldValue(
        'listingCardData.template.data.card.customization.cardOrientation',
        value
      )
    } else {
      setFieldValue(
        'listingCardData.template.data.card.customization.cardAlignment',
        value
      )
    }
  }

  const handleSelection = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = event.target.value
    const isInCard = selectedValue === 'inCard'

    await setFieldValue('logoPosition', selectedValue)
    setFieldValue(
      'listingCardData.template.data.cardHeader.shouldShowLogoInCardHeader',
      !isInCard
    )
  }

  const logoOptions: RadioButtonGroupMapping[] = [
    {
      key: 'inCard',
      label: 'Keep logo in cards',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
    {
      key: 'common',
      label: 'Common logo across the layout',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
  ]

  const checkedValue = useMemo(() => {
    return listingCardData?.template?.data?.cardHeader
      ?.shouldShowLogoInCardHeader === false
      ? 'inCard'
      : 'common'
  }, [listingCardData?.template?.data?.cardHeader?.shouldShowLogoInCardHeader])

  return (
    <div className={clsx(classes.container, classes.root, classes.content)}>
      <div className={classes.textContentWrapper}>
        <Typography
          // className={commonClasses.cardTextHeader}
          className={classes.textHeading}
          data-testid="card-styling-text"
        >
          Card's styling
        </Typography>
      </div>

      <div className={classes.cardProperties}>
        <Typography className={classes.alignmentAndOrientationContainer}>
          Card Orientation
        </Typography>
        {cardOrientations.map(orientation => (
          <div
            data-testid="card-orientation"
            key={orientation}
            onClick={handleAlignmentChange(orientation, 'orientation')}
            className={clsx(
              classes.orientationCard,
              orientation ===
                (listingCardData?.template?.data?.card?.customization
                  .cardOrientation || '')
                ? classes.selected
                : ''
            )}
          >
            <div
              className={clsx(
                classes.orientation,
                orientation === 'vertical'
                  ? classes.vertical
                  : classes.horizontal
              )}
            ></div>
            <Typography
              className={clsx(
                classes.orientationText,
                orientation === 'vertical'
                  ? classes.verticalOrientation
                  : classes.horizontalOrientation
              )}
            >
              {capitalize(orientation)}
            </Typography>
          </div>
        ))}
      </div>
      <div className={classes.cardProperties}>
        <Typography className={classes.alignmentAndOrientationContainer}>
          Card content alignment
        </Typography>
        {alignments.map(align => (
          <div
            data-testid="card-alignment"
            key={align.id}
            onClick={handleAlignmentChange(align.id, 'alignment')}
            className={clsx(
              classes.icon,
              classes.alignmentIcon,
              align.id ===
                (listingCardData?.template?.data?.card?.customization
                  .cardAlignment || '')
                ? classes.selected
                : ''
            )}
          >
            <FontAwesomeIcon icon={align.icon} />
          </div>
        ))}
      </div>
      <div
        className={classes.logoPositionSection}
        data-testid="logo-position-section"
      >
        <Typography
          className={classes.logoPositionText}
          data-testid="logo-position-title"
        >
          Logo position
        </Typography>

        <div className={classes.radiobuttonStyle}>
          <RadioButtonsV2
            name={'logoPosition'}
            handleChange={handleSelection}
            checkedValue={{
              key: checkedValue,
              value: checkedValue,
            }}
            radioButtonMappings={logoOptions}
            vertical={true}
            gapBetween="0px"
          />
        </div>
      </div>
    </div>
  )
}
